module.exports = __webpack_public_path__ + "static/img/video.8e7b88c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/video.png
// module id = KWJY
// module chunks = 1